<template>
  <path fill="#355d84" :style="{ fill : $attrs.fgColor }"
        d="m47.93,22.35C46.76,3.71,25.03-6.45,9.95,4.53c-1.8-1.35-3.61-2.71-5.52-3.9C3.61.06,2.54-.22,1.6.22-.37,1.07.05,3.05.02,4.8c-.01,6.55,0,13.11,0,19.66.12,15.28,15.28,26.73,30.02,22.74,10.97-2.72,18.81-13.58,17.9-24.85Zm-10.49-.85c-3.28,3.27-6.55,6.55-9.83,9.82-1.03,1.03-2.07,2.07-3.1,3.1-.74.81-1.66,1.48-2.75,1.69-1.49.33-3.13-.12-4.23-1.19-.38-.45-7.59-7.51-7.82-7.85-.52-.62-.87-1.38-1.01-2.18-.66-3.19,2.54-6.21,5.69-5.37,2.04.3,4.89,4.14,6.38,5.38,2.66-2.66,5.32-5.32,7.98-7.98,1.24-1.13,2.26-2.54,3.7-3.43,5.28-2.61,9.54,4.31,4.99,8Z"/>
</template>

<script>
export default {
  name: "svgBale"
}
</script>

<style scoped>

</style>